import { useEffect } from "react";
import "@/App.css";
import {
  BrowserRouter, Routes, Route, Outlet, useLocation,
} from "react-router-dom";
import Lenis from "@studio-freight/lenis";

import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { SiteProvider } from "@/context/SiteContext";
import { PageContentProvider } from "@/context/PageContentContext";

import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

import Home from "@/pages/Home";
import About from "@/pages/About";
import ProductDevelopment from "@/pages/ProductDevelopment";
import FoodConsultancy from "@/pages/FoodConsultancy";
import RawMaterialSupply from "@/pages/RawMaterialSupply";
import Brands from "@/pages/Brands";
import FranchiseSolutions from "@/pages/FranchiseSolutions";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

function PublicLayout() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.3,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    const id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);

  return (
    <div className="App grain min-h-screen bg-cream flex flex-col" data-testid="public-layout">
      <SiteHeader />
      <div className="flex-1">
        <Outlet />
      </div>
      <SiteFooter />
      <FloatingWhatsApp />
    </div>
  );
}

function AdminShell() {
  return (
    <div data-testid="admin-shell">
      <Outlet />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <SiteProvider>
        <PageContentProvider>
          <AuthProvider>
            <CartProvider>
              <ScrollToTop />
              <Routes>
                <Route element={<PublicLayout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/product-development" element={<ProductDevelopment />} />
                  <Route path="/food-consultancy" element={<FoodConsultancy />} />
                  <Route path="/raw-material-supply" element={<RawMaterialSupply />} />
                  <Route path="/brands" element={<Brands />} />
                  <Route path="/franchise-solutions" element={<FranchiseSolutions />} />
                  <Route path="/contact" element={<Contact />} />
                </Route>

                <Route path="/admin" element={<AdminShell />}>
                  <Route index element={<AdminLogin />} />
                  <Route path="dashboard/*" element={<AdminDashboard />} />
                </Route>
              </Routes>
            </CartProvider>
          </AuthProvider>
        </PageContentProvider>
      </SiteProvider>
    </BrowserRouter>
  );
}
